module.exports = __webpack_public_path__ + "img/magazine.2212144.jpg";